module.exports = __webpack_public_path__ + "media/images/business/i-contact-2f78ce4112204027ff38e249a849f80b.svg";